// extracted by mini-css-extract-plugin
module.exports = {"packArtWorkContainer":"PackSettings_packArtWorkContainer__G4DWL"};